// extracted by mini-css-extract-plugin
export var carousel = "TestimonialCarousel-module--carousel--bf68c";
export var carousel__btn = "TestimonialCarousel-module--carousel__btn--03f87";
export var carousel__descLine = "TestimonialCarousel-module--carousel__descLine--0c3f1";
export var carousel__desktopOnly = "TestimonialCarousel-module--carousel__desktopOnly--2ec3e";
export var carousel__details = "TestimonialCarousel-module--carousel__details--00443";
export var carousel__inner = "TestimonialCarousel-module--carousel__inner--00728";
export var carousel__item = "TestimonialCarousel-module--carousel__item--56cd0";
export var carousel__item___active = "TestimonialCarousel-module--carousel__item___active--6c5f1";
export var carousel__mobileBottom = "TestimonialCarousel-module--carousel__mobileBottom--34f34";
export var carousel__mobileNavigation = "TestimonialCarousel-module--carousel__mobileNavigation--559f4";
export var carousel__mobileOnly = "TestimonialCarousel-module--carousel__mobileOnly--ce34f";
export var carousel__quote = "TestimonialCarousel-module--carousel__quote--2c4d3";
export var carousel__video = "TestimonialCarousel-module--carousel__video--0d621";